import styles from './ErrorDisplay.module.css'

/**
 * @typedef {Interface} AppParams
 * @param {String} [title] title of the app
 * @param {Error | null} err
 * @param {String} [url] url
 * @param {any} children
 */
interface AppParams {
  title?: string
  err: Error | null
  url?: string
  children?: any
}

/**
 * Error function to display error while api call or other operation
 * @param {AppParams}
 * @returns {JSX.Element}
 */
export default function App({ title, err, url, children }: AppParams) {
  return (
    <div className={styles.errorWrapper}>
      <div className={styles.errorDisplay}>
        <img className={styles.errorImg} src="/img/whoops.svg" alt="whoopsie" />
        <h2 className={styles.errorHeader}>{title ? title : 'Whoopsie'}</h2>
        {url ? (
          <p className={styles.errorDescription}>
            An error occurred whilst attempting to load <code>{url}</code>:
          </p>
        ) : null}
        <pre className={styles.errorMessage}>{err?.toString() || ''}</pre>
        {children ? (
          children
        ) : (
          <p className={styles.errorDescription}>
            Try refreshing the page, if the problem persists then let us know at <a href="mailto:support@arnowa.com">support@arnowa.com</a>.
          </p>
        )}
      </div>
    </div>
  )
}
